import styles from './ArticleFooter.module.scss'
import { socials } from 'constants/constants'
import { handleScrollToTop } from 'utils/helpers'
import { useTranslation } from 'next-i18next/pages'
import { Button } from '@boltenergy-be/design-system'
import Link from 'components/link/Link'

const ArticleFooter = () => {
  // i18n
  const { t } = useTranslation(['blog'])

  return (
    <section className={styles.footer}>
      <div className={styles['social-plug']}>
        {t('footer.followOn')}{' '}
        <Link as="a" href={socials.facebook} target="_blank" variant="inline">
          Facebook
        </Link>{' '}
        {t('footer.and')}{' '}
        <Link as="a" href={socials.instagram} target="_blank" variant="inline">
          Instagram
        </Link>
      </div>
      <Button representation="link" onClick={() => handleScrollToTop()} trailingIcon="chevronUp">
        {t('footer.toTop')}
      </Button>
    </section>
  )
}

export default ArticleFooter
